import http from '@/utils/http';
import i18n from '@/main';
import axios from 'axios';
import { t } from 'element-ui/lib/locale';

export default {
    consultar(tipo, documento, salvar = true, arquivo, idRequest = 'semId') {
        return http.post({
            url: `/diagnostico/buscar-dados/socioambiental/${tipo}/${documento}/${idRequest}?salvar=${salvar}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            ),
            data: { arquivo: arquivo }
        });
    },

    consultarEmLote(
        tipo,
        documento,
        salvar = true,
        lockscreen = true,
        arquivo,
        idRequest = 'semId'
    ) {
        return http.post({
            url: `/diagnostico/buscar-dados/socioambiental/${tipo}/${documento}/${idRequest}?salvar=${salvar}`,
            lockScreen: lockscreen,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            ),
            data: { arquivo: arquivo }
        });
    },

    consultarMultiplos(tipo, documento, arquivo, idRequest) {
        return http.post({
            url: `/diagnostico/buscar-dados/socioambiental/${tipo}/${documento}/${idRequest}?salvar=true`,
            lockScreen: false,
            data: { arquivo: arquivo }
        });
    },

    buscarPorId(idDiagnostico) {
        return http.get({
            url: `diagnostico-socioambiental/${idDiagnostico}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoDiagnosticoSocioambientalSalvo'
            )
        });
    },

    realizarDiagnosticoSocioambientalProtocolo(payload) {
        return http.post({
            url: '/diagnostico-socioambiental/listagem-protocolo',
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            ),
            data: payload
        });
    },

    analisarBuffer(geometria, idDiagnosticoSocioambiental) {
        return http.post({
            url: `/diagnostico/${idDiagnosticoSocioambiental}/analisar-buffer`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambientalDasAreasProximas'
            ),
            data: { geometrias: geometria }
        });
    },

    exportarPdf(params) {
        return http.post({
            url: '/diagnostico/exportar/pdf',
            data: { dados: params },
            lockScreen: false
        });
    },

    async verifyUrl(url) {
        try {
            const response = await http.get({
                url: url,
                lockScreen: true,
                lockMessage: i18n.t(
                    'mensagens.sistema.verificandoDisponibilidadeDoServico'
                )
            });
            if (response.status >= 200 && response.status <= 299) {
                return true;
            }
            return false;
        } catch (err) {
            return false;
        }
    },

    consultaControleDiagnostico(body, { page, size, sort }) {
        return http.post({
            url: `/diagnostico/filtrar-relatorio?page=${
                page - 1
            }&size=${size}&sort=${sort}`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeDiagnosticos')
        });
    },

    graficoControleDiagnostico(body) {
        return http.post({
            url: `/diagnostico/grafico`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoGraficosDeDiagnosticos'
            )
        });
    },

    realizarDiagnosticoCadastroTerritorio(idTerritorio) {
        return http.get({
            url: `diagnostico-socioambiental/cadastro-territorio/${idTerritorio}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            )
        });
    },

    async exportarControleRequisicaoDiagnostico(body) {
        const fileLink = document.createElement('a');
        try {
            const response = await http.post({
                url: `/diagnostico/requisicao-xlsx`,
                data: body,
                responseType: 'blob',
                lockScreen: true,
                lockMessage: i18n.t(
                    'mensagens.sistema.preparandoDadosParaDownload'
                )
            });
            if (response.status === 200) {
                const fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                fileLink.href = fileURL;
                const filenameRegex = /filename=['"]?([^;\r\n"']*)['"]?;?/;
                const contentDisposition =
                    response.headers['content-disposition'];

                fileLink.setAttribute(
                    'download',
                    filenameRegex.exec(contentDisposition)[1]
                );
                document.body.appendChild(fileLink);

                fileLink.click();
                return Promise.resolve();
            }
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarDiagnosticoCarDoTerritorio(territorio) {
        return new Promise((resolve, reject) => {
            if (
                territorio &&
                territorio.dadosTerritorio &&
                territorio.dadosTerritorio.cars &&
                territorio.dadosTerritorio.cars.length
            ) {
                const promises = [];
                territorio.dadosTerritorio.cars.forEach(car => {
                    if (car.codigo) {
                        const request = http.get({
                            url: `/diagnostico/${territorio.idDiagnosticoSocioambiental}/car/${car.codigo}`
                        });
                        promises.push(request);
                    }
                });
                Promise.all(promises)
                    .then(responses => {
                        const responseCars = [];
                        responses.forEach(({ data, status }) => {
                            if (status === 200 && data && data.imovel) {
                                responseCars.push(data);
                            }
                        });
                        resolve(responseCars);
                    })
                    .catch(error => {
                        reject(error);
                    });
            } else {
                resolve([]);
            }
        });
    },
    consultarSocioambientalPY(geometria, idRequest) {
        return http.post({
            url: `diagnostico/buscar-dados/socioambiental/GEOMETRIA/geometria/${idRequest}?salvar=true`,
            lockScreen: false,
            data: { arquivo: geometria }
        });
    },
    async processamentoLote(arquivo) {
        const url = `${process.env.VUE_APP_HTTP_PATH}/diagnostico/processamento-lote/socioambiental`;
        const formData = new FormData();
        const source = axios.CancelToken.source();

        formData.append('arquivo', arquivo.raw);
        setTimeout(() => {
            source.cancel('Operação cancelada');
        }, 5000);

        try {
            const response = await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                cancelToken: source.token
            });
            return response;
        } catch (error) {
            if (axios.isCancel(error)) {
                const error = new Error(
                    t(
                        'mensagens.diagnosticoSocioambiental.cargaEmLote.processamentoLoteSucesso'
                    )
                );
                error.code = 'CANCELLED';
                throw error;
            }
            throw error;
        }
    },
    statusProcessamentoEmLote() {
        return http.get({
            url: 'diagnostico/processamento-lote/socioambiental-status',
            lockScreen: false
        });
    },
    async cancelarProcessamentoEmLote(jobExecutionId) {
        const url = `${process.env.VUE_APP_HTTP_PATH}/diagnostico/processamento-lote/socioambiental-cancelar`;
        try {
            const response = await axios.post(url, { jobExecutionId });

            return response;
        } catch (error) {
            throw error;
        }
    },
    async resultadoProcessamentoEmLote(id) {
        const url = `${process.env.VUE_APP_HTTP_PATH}/diagnostico/processamento-lote/socioambiental-download/${id}`;
        try {
            const response = await axios.get(url, { responseType: 'blob' });
            console.log(
                'response resultadoProcessamentoEmLote',
                response,
                response.data
            );
            const fileURL = window.URL.createObjectURL(
                new Blob([response.data])
            );
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            const disposition = response.headers['content-disposition'];
            let filename = 'relatorio.xlsx';
            if (disposition && disposition.indexOf('filename=') !== -1) {
                const filenameRegex = /filename=["']?([^"']+)["']?/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1];
                }
            }
            fileLink.setAttribute('download', filename);
            document.body.appendChild(fileLink);
            fileLink.click();
            fileLink.remove();
            return response;
        } catch (error) {
            throw error;
        }
    }
};
